import React from "react";
import { Button, Grid, Tooltip } from "@material-ui/core";

import columns from "./columns";
import Table from "../../../../../components/Table";

interface Props {
  lineItems: any[];
  openEditLineItem: (...args: any) => void;
  isFrozen?: boolean;
  contractType?: string;
  exemptContractTypes?: string[];
}

export default ({
  lineItems,
  openEditLineItem,
  isFrozen,
  contractType,
  exemptContractTypes = []
}: Props): JSX.Element => {
  const blockedByFreeze =
    !!isFrozen && !(contractType && exemptContractTypes.includes(contractType));
  const button = (
    <Button
      size="small"
      color="primary"
      variant="outlined"
      disabled={blockedByFreeze}
      onClick={(): void => openEditLineItem("", { type: "Add" })}
    >
      + New Line Item
    </Button>
  );

  return (
    <div>
      <Table columns={columns} rows={lineItems} allowEmpty />
      <Grid container item direction="row-reverse" style={{ paddingTop: 16 }}>
        {blockedByFreeze ? (
          <Tooltip title="Receivables are frozen for this client. Cannot add line items.">
            <span>{button}</span>
          </Tooltip>
        ) : (
          button
        )}
      </Grid>
    </div>
  );
};
